import angular from 'angular';
import { commentButtonComponent } from './commentButtonComponent';
import 'components/sharpr/modal/modalModule';
import 'components/sharpr/api/apiModule';

angular.module('sh.commentButton', ['sh.modal', 'sh.api']).component('shCommentButton', commentButtonComponent());
